__webpack_require__.p = "https://static.flicknovelcdn.com/reader-website-static/prod_4830894_84_d31b7195/_next/";